// extracted by mini-css-extract-plugin
export default {"boxLabel":"CustomerPortalThemeCard_boxLabel__HaGQf"};